// extracted by mini-css-extract-plugin
export default {"section":"loader_section__UrYFo","loader":"loader_loader__M-FUL","animloader":"loader_animloader__ej48a"};